// MS funnel GA4/GTM event names — keep in sync with the tracking sheet's PARCOURS MUTUELLE SANTÉ section.
export enum HealthTrackingEnum {
    FunnelAccess = 'ms_funnel_access',
    ProfileSelection = 'ms_profile_selection',
    BirthDate = 'ms_birth_date',
    Profession = 'ms_profession',
    Location = 'ms_location',
    CoverageDate = 'ms_coverage_date',
    CurrentCoverage = 'ms_current_coverage',
    Needs = 'ms_needs',
    ContactDetails = 'ms_contact_details',
    LeadGenerated = 'ms_lead_generated',
    // Tiède = devis demandé, chaud = pré-souscription chez l'assureur : même échelle que l'AE (clic offre / adhésion).
    LeadGeneratedWarm = 'ms_lead_generated_warm',
    LeadGeneratedHot = 'ms_lead_generated_hot',
    CtaCallback = 'ms_cta_callback',
    CtaQuote = 'ms_cta_quote',
    CtaInsurer = 'ms_cta_insurer',
}
